/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const userCheckPhoneRetrieveQueryCountryCodeSchema = z.string().min(1).max(4).optional().default("+7");

export const userCheckPhoneRetrieveQueryPhoneSchema = z.string().min(1).max(20);

export const userCheckPhoneRetrieveStatus200Schema = z.any();

export const userCheckPhoneRetrieveStatus404Schema = z.any();

export const userCheckPhoneRetrieveResponseSchema = z.union([userCheckPhoneRetrieveStatus200Schema, userCheckPhoneRetrieveStatus404Schema]);
